// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_italic-text--line"><path id="Union" d="M20 5H15.6934L10.4434 19H15V21H4V19H8.30664L13.5566 5H9V3H20V5Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_italic-text--line"><path id="Union" d="M20 5H15.6934L10.4434 19H15V21H4V19H8.30664L13.5566 5H9V3H20V5Z" style="fill: currentColor"/></g></svg>`;

export const ItalicText: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
